import {
  createStyles,
  makeStyles,
  TextField,
  Theme,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";
import { useQueryParams } from "../../utils/queryParams";
import { ScoringOption } from "../store/types";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 14,
      "& .MuiInputBase-input": {
        backgroundColor: theme.palette.common.white,
        borderRadius: 12,
        padding: "6px !important",
        overflow: "hidden",
      },
      "& .MuiFormControl-root": {
        width: "100%",
        height: 68,
      },
      "& .MuiFilledInput-inputMarginDense": {
        paddingTop: 14,
        paddingBottom: 14,
      },
      "& .MuiAutocomplete-inputRoot": {
        backgroundColor: theme.palette.common.white,
        borderRadius: 12,
        height: "100%",
      },
      "& .MuiInputLabel-formControl": {
        color: theme.palette.common.white,
      },
    },
  })
);

interface OwnProps {
  readonly options: ScoringOption[];
  readonly setScoring: (scoring: string) => void;
}

type Props = OwnProps;

const useWidth = () => {
  const theme = useTheme();
  const keys = [...theme.breakpoints.keys].reverse();
  return (
    keys.reduce((output: any, key: any) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key));
      return !output && matches ? key : output;
    }, null) || "xs"
  );
};

const ScoringInput = (props: Props) => {
  const classes = useStyles();
  const { options, setScoring } = props;
  const width = useWidth();
  const queryParams = useQueryParams();
  const site = queryParams.get("site")?.toLowerCase() || "espn_ppr";

  React.useEffect(() => {
    setScoring(site);
  }, []);

  return (
    <div className={classes.root}>
      <Autocomplete
        autoComplete
        blurOnSelect
        disablePortal={["xs"].indexOf(width) >= 0 ? false : true}
        options={options}
        getOptionLabel={(option) => `${option.name}`}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Scoring"
            label="League Scoring Settings"
          />
        )}
        defaultValue={options.find((o) => o.id === site)}
        onChange={(e, value: any, reason) => {
          if (reason === "select-option") {
            setScoring(value.id);
          }
          if (reason === "clear") {
            setScoring("");
          }
        }}
      />
    </div>
  );
};

export default ScoringInput;
